import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import BotonBorrar from "../../shared/botones/BotonBorrar";
import moment from "moment";

class FilaAsignados extends Component {
  state = {};

  handleAlta = () =>
    this.props.handleRowClick(
      this.props.alumno.key,
      this.props.alumno.fechaAlta,
      "fechaAlta",
      "Fecha de Alta en la actividad"
    );

  handleBaja = () =>
    this.props.handleRowClick(
      this.props.alumno.key,
      this.props.alumno.fechaBaja,
      "fechaBaja",
      "Fecha de Baja en la actividad"
    );

  render() {
    const { alumno } = this.props;
    return (
      <Table.Row>
        <Table.Cell onClick={this.handleAlta}>
          {moment(alumno.fechaAlta).format("DD/MM/YYYY")}
        </Table.Cell>
        <Table.Cell style={{ cursor: "pointer" }} onClick={this.handleBaja}>
          {moment(alumno.fechaBaja, "YYYYMMDD").isValid()
            ? moment(alumno.fechaBaja).format("DD/MM/YYYY")
            : "-"}
        </Table.Cell>
        <Table.Cell>{alumno.nombre}</Table.Cell>
        <Table.Cell>{alumno.apellido1}</Table.Cell>
        <Table.Cell>{alumno.apellido2}</Table.Cell>
        <Table.Cell>{alumno.edad}</Table.Cell>
        <Table.Cell>{alumno.contacto.telefono}</Table.Cell>
        {this.props.editable && (
          <Table.Cell>
            <BotonBorrar
              data={{ keyAlumno: alumno.key, idAlumno: alumno.id }}
              handleClick={this.props.handleBorrarAlumno}
              headerText={`Eliminar Alumno`}
              content={`¿Desea eliminar a ${alumno.nombre} ${
                alumno.apellido1
              } ${alumno.apellido2}
              de la lista?`}
            />
          </Table.Cell>
        )}
        <Table.Cell>{alumno.iban}</Table.Cell>
      </Table.Row>
    );
  }
}

export default FilaAsignados;



// WEBPACK FOOTER //
// ./src/pages/asignacionAlumnos/alumnosAsignados/FilaAsignados.jsx